// extracted by css-extract-rspack-plugin
export default {"link":"VpD4KT","icon":"IKYdyU","iconTrialing":"xvN65s","statusIndicator":"v8RqlW","statusPing":"w_Gnvq","ping":"IgP7jZ","statusDot":"kJOBXb"};